import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import KnowledgeSearch from "./KnowledgeSearch";
const CompactKnowledgeBase = ({
  isKnowledgeActive
}) => {
  return isKnowledgeActive && /*#__PURE__*/React.createElement(KnowledgeSearch, null);
};
export default CompactKnowledgeBase;
CompactKnowledgeBase.propTypes = {
  containerHeight: PropTypes.string,
  isKnowledgeActive: PropTypes.bool.isRequired,
  showClose: PropTypes.bool
};
CompactKnowledgeBase.defaultProps = {
  containerHeight: "64px",
  showClose: false
};